import { render, staticRenderFns } from "./customUpload.vue?vue&type=template&id=4910bc7b&scoped=true"
import script from "./customUpload.vue?vue&type=script&lang=js"
export * from "./customUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910bc7b",
  null
  
)

export default component.exports